import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PortalService} from "../../services/portal.service";

/**
 * Component for accepting the terms for this tool
 */
@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    standalone: false
})
export class TermsComponent implements OnInit {
  /**
   * Prefic for all texkeys that are used here
   */
  @Input() textPrefix: string;

  /**
   * Event when the checkbox is changed.
   */
  @Output() onUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
   * toggle for showing/hiding the detailed information
   */
  showMore: boolean = false;

  /**
   * current portalid
   */
  portalId: string;

  /**
   * constructor
   * @param portalService
   */
  constructor(private portalService: PortalService) {}

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    // set portalId
    this.portalId = this.portalService.currentPortalId;
  }

  /**
   * if the checkbox is changed.
   * @param event
   */
  onChange(event): void {
    this.onUpdate.emit(event.target.checked);
  }

}
